import { Injectable, signal } from '@angular/core';
import { SpacesService } from '@generated/services/spaces.service';
import { SpaceDto } from '@generated/models';

@Injectable({
  providedIn: 'root'
})
export class SpaceService {
  private readonly SPACE_KEY = 'selected_space';

  spaces = signal<SpaceDto[]>([]);
  loaded = signal(false);
  currentSpace = signal<SpaceDto | null>(this.getSavedSpace());

  constructor(private spacesApi: SpacesService) {}

  loadSpaces(): void {
    this.spacesApi.apiSpacesGet().subscribe({
      next: (spaces) => {
        this.spaces.set(spaces);
        this.loaded.set(true);

        const saved = this.getSavedSpace();
        const exists = saved && spaces.some(s => s.id === saved.id);

        if (!exists) {
          const defaultSpace = spaces.find(s => s.is_default) || spaces[0];
          if (defaultSpace) {
            this.setCurrentSpace(defaultSpace, false);
          }
        }
      }
    });
  }

  setCurrentSpace(space: SpaceDto, reload = true): void {
    this.currentSpace.set(space);
    localStorage.setItem(this.SPACE_KEY, JSON.stringify(space));
    if (reload) {
      window.location.reload();
    }
  }

  getCurrentSpaceId(): string | null {
    return this.currentSpace()?.id || null;
  }

  private getSavedSpace(): SpaceDto | null {
    try {
      const saved = localStorage.getItem(this.SPACE_KEY);
      return saved ? JSON.parse(saved) : null;
    } catch {
      return null;
    }
  }
}
